var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField, } from "formik";
import React from "react";
import styled from "styled-components";
import { Label } from "../../Text";
import { TextInput, HTMLInput } from "../../TextInput";
import { colors } from "../../Theme/colors";
import { Div } from "../../utils";
import { ErrorMessage, useDisplayErrorMessage } from "../fieldHelpers";
export const FormikNameInput = (_a) => {
    var _b, _c, _d, _e;
    var props = __rest(_a, []);
    const firstNameField = useField("firstName");
    const lastNameField = useField("lastName");
    const shouldDisplayError1 = useDisplayErrorMessage(firstNameField[0].value);
    const shouldDisplayError2 = useDisplayErrorMessage(lastNameField[0].value);
    const fieldCotainsError = (field) => field[1].touched && !!field[1].error && field[1].error !== "";
    const displayError = fieldCotainsError(firstNameField) || fieldCotainsError(lastNameField);
    const error = ((_b = firstNameField[1]) === null || _b === void 0 ? void 0 : _b.error) || ((_c = lastNameField[1]) === null || _c === void 0 ? void 0 : _c.error);
    return (React.createElement(Div, Object.assign({ w100: true }, props),
        React.createElement(Label, { mb: 5, c: colors.black70 }, "Name"),
        React.createElement(Div, { dflex: true },
            React.createElement(LeftField, { hasError: shouldDisplayError1 &&
                    displayError &&
                    fieldCotainsError(firstNameField), value: ((_d = firstNameField[0]) === null || _d === void 0 ? void 0 : _d.value) || "", placeholder: "First or given name...", onBlur: () => firstNameField[2].setTouched(true), onChange: (v) => firstNameField[2].setValue(v) }),
            React.createElement(RightField, { hasError: displayError &&
                    shouldDisplayError2 &&
                    fieldCotainsError(lastNameField), value: ((_e = lastNameField[0]) === null || _e === void 0 ? void 0 : _e.value) || "", placeholder: "Last or family name...", onBlur: () => lastNameField[2].setTouched(true), onChange: (v) => lastNameField[2].setValue(v) })),
        shouldDisplayError1 &&
            shouldDisplayError2 &&
            displayError &&
            !!error && React.createElement(ErrorMessage, { msg: error })));
};
const LeftField = styled(TextInput) `
  ${HTMLInput} {
    border-radius: 4px 0 0 4px;
    border-right: none;
  }
`;
const RightField = styled(TextInput) `
  ${HTMLInput} {
    border-radius: 0 4px 4px 0;
  }
`;
//# sourceMappingURL=FormikNameInput.js.map